import { atom, useRecoilValue, useSetRecoilState } from 'recoil';

export const hintVisible = atom<boolean>({
    key: 'hintVisible',
    default: true,
});

export const useHintVisibleValue = () => useRecoilValue(hintVisible);
export const useHintVisibleSetState = () => useSetRecoilState(hintVisible);
